import '../styles/LandingPage/Researchpillars.css';
import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const pillars = [
  {
    num: '01',
    color: 'pt-teal',
    icon: 'ti-file-description',
    title: 'Financial Reporting & Capital Frameworks',
    desc: 'IFRS 17 implementation, CSM behaviour, risk adjustment methodologies, and embedded value metrics.',
    route: '/research/financial-reporting',
  },
  {
    num: '02',
    color: 'pt-green',
    icon: 'ti-chart-dots',
    title: 'Solvency & Capital Management',
    desc: 'Economic capital modelling, stress testing for African insurers, ORSA implementation, and capital optimisation.',
    route: '/research/solvency-capital',
  },
  {
    num: '03',
    color: 'pt-teal',
    icon: 'ti-activity',
    title: 'Mortality & Morbidity Studies',
    desc: 'Experience analysis, lapse and persistency behaviour, mortality improvement assumptions, and data credibility.',
    route: '/research/mortality-morbidity',
  },
  {
    num: '04',
    color: 'pt-crimson',
    icon: 'ti-scale',
    title: 'Asset-Liability & Investment Risk',
    desc: 'ALM modelling, duration mismatch analysis, inflation risk in long-term life products, and scenario generation.',
    route: '/research/asset-liability',
  },
  {
    num: '05',
    color: 'pt-brand',
    icon: 'ti-cpu',
    title: 'Innovation & Emerging Risk',
    desc: 'Climate actuarial modelling, parametric insurance, microinsurance sustainability, and AI in actuarial science.',
    route: '/research/innovation-risk',
  },
];

export default function ResearchPillars() {
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.animationPlayState = 'running';
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );

    cardsRef.current.forEach((card) => {
      if (card) {
        card.style.animationPlayState = 'paused';
        observer.observe(card);
      }
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="research-section" id="research" ref={sectionRef}>

      {/* ── Header ── */}
      <div className="rs-header">
        <div className="rs-header-left">
          <div className="s-label">Core Research Areas</div>
          <h2>Five Pillars of<br />Actuarial Inquiry.</h2>
          <p className="s-intro">
            Our research agenda addresses the defining challenges facing insurers,
            pension funds, and regulators across Africa and emerging markets.
          </p>
        </div>

        <div className="rs-header-right">
          <div className="rs-meta-line">
            <i className="ti ti-map-pin" aria-hidden="true" />
            Africa &amp; Emerging Markets
            <span className="rs-meta-dot" />
            Independent Research
          </div>
          <div className="rs-meta-line">
            <i className="ti ti-users" aria-hidden="true" />
            Insurers · Pension Funds · Regulators
          </div>
          <div className="rs-meta-line">
            <i className="ti ti-calendar" aria-hidden="true" />
            Phase 1 · Ongoing
          </div>
        </div>
      </div>

      {/* ── Pillars ── */}
      <div className="pillars-grid">
        {pillars.map((p, index) => (
          <div
            className={`pillar-card ${p.color}`}
            key={p.num}
            ref={(el) => { cardsRef.current[index] = el; }}
          >
            <div className="pillar-icon-row">
              <div className="pillar-icon-wrap">
                <i className={`ti ${p.icon}`} aria-hidden="true" />
              </div>
              <span className="pillar-num-badge">{p.num}</span>
            </div>

            <div className="pillar-title">{p.title}</div>
            <div className="pillar-desc">{p.desc}</div>

            <div className="pillar-footer">
              <Link to={p.route} className="pillar-cta">
                Read more <i className="ti ti-arrow-right" aria-hidden="true" />
              </Link>
            </div>

            <div className="pillar-num">{p.num}</div>
          </div>
        ))}
      </div>
    </section>
  );
}